export const LESSONS_FEATURE_KEY = 'lessons';
